import { render, staticRenderFns } from "./door_period.vue?vue&type=template&id=c9f1276c&"
import script from "./door_period.vue?vue&type=script&lang=ts&"
export * from "./door_period.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports